<template>
  <v-dialog
    scrollable
    :width="computedWidth"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    :value="show"
    @click:outside="close"
  >
    <v-card :loading="loading">
      <identity v-if="show === 'identity'" @close="close" />

      <records
        v-if="show === 'records'"
        :loading.sync="loading"
        @close="close"
      />

      <sales v-if="show === 'sales'" :loading.sync="loading" @close="close" />
    </v-card>
  </v-dialog>
</template>

<script>
import Identity from "./Identity";
import Records from "./Records";
import Sales from "./Sales";

export default {
  name: "FiscalMenuDialog",
  components: {
    Identity,
    Records,
    Sales,
  },
  props: {
    value: [Object, String],
  },
  data: () => ({
    loading: false,
  }),
  computed: {
    computedWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case "sm":
          return "80%";
        case "md":
          return "50%";
        case "lg":
          return "50%";
        case "xl":
          return "50%";
      }
      return "auto";
    },
    show() {
      if (typeof this.value === "string") {
        return this.value;
      }
      return this.value?.value;
    },
  },
  methods: {
    close() {
      this.$emit("input", null);
    },
  },
};
</script>
